export { default as getTemplateDetails } from './use-set-template-details';
